import React from 'react';
import clsx from 'clsx';
import { TypedMemo } from '../../common/types';
import { Panel } from '../../music24/components/primitives/Panel';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole panel; each part uses its own slice of it */
import styles from './PresavePanel.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface PresaveCounterCardProps {
  label: string;
  /** Already formatted — the cards print counts and percentages alike. */
  value: string;
  /** A word after the figure, as in "612 collected". */
  unit?: string;
  /** Today's delta, or a share. Green when it is movement, grey when it is not. */
  delta?: string;
  deltaIsPositive?: boolean;
  /** An extra class on the tile, as the tinted subscribers card. */
  className?: string;
  testId?: string;
}

/** One figure with its label, its delta and whatever the card draws under it. */
const PresaveCounterCardComponent: React.FC<React.PropsWithChildren<PresaveCounterCardProps>> = ({
  label,
  value,
  unit,
  delta,
  deltaIsPositive,
  className,
  testId,
  children,
}) => {
  return (
    <Panel nested className={clsx(styles.card, className)} data-testid={testId}>
      <div className={styles.cardHead}>
        <span className={styles.cardLabel}>{label}</span>
        {delta !== undefined && (
          <span className={clsx(styles.delta, deltaIsPositive === true && styles.deltaUp)}>{delta}</span>
        )}
      </div>
      <div className={styles.cardValue}>
        {value}
        {/* A real space, so the text reads "0 collected", not "0collected" (QA E). */}
        {unit !== undefined && <small className={styles.cardValueUnit}> {unit}</small>}
      </div>
      {children}
    </Panel>
  );
};

export const PresaveCounterCard = TypedMemo(PresaveCounterCardComponent);
